import { getArticleDatasources } from '@monoimin/storyblok/getArticleDatasources';

import type {
  Locales,
  DataSourceEntry,
  ArticleFolders,
} from '@monoimin/sb-types';

const transformArticleDatasourcesRes = ([countries, categories]: [
  DataSourceEntry[],
  DataSourceEntry[]
]) => [
  countries.map((c) => ({ ...c, value: `country/${c.dimension_value}` })),
  categories,
];

export const getArticleDatasourcesForSitemap = (
  folder: ArticleFolders,
  locale: Locales
) => getArticleDatasources(folder, locale).then(transformArticleDatasourcesRes);
